import { Injectable } from '@angular/core';

export interface Order {
    addressId: string;
    companyId: string;
    customerAddress: string;
    customAddress?: string | null;
    customerId: string;
    customerName: string;
    divisionId: string;
    facilityId: string;
    grossValue: string;
    isCustom?: number;
    netAmount: string;
    orderId: number;
    orderNumber: string;
    orderTypeId: string;
    orderValue: string;
    outstanding: string;
    phoneNumber: string;
    requestedDate: string;
    status: number;
    totalDiscountValue: string;
    totalOverdue: string;
    userIdResponsible: string;
    vatAmount: string;
    vatRegistrationNo: string;
    whsId: string;
    dispatchStatus: string; // 'Pending' | 'Dispatched'
    pkllId : string; // Picking List ID
}
export interface Route {
    id: string;
    name: string;
}
export interface PickingList {
    orders: Order[];
    vehicleNo: string;
    driverNo: string;
    createdAt: Date;
}

@Injectable({ providedIn: 'root' })
export class PickingListStorageService {
    private key = 'pickingLists';

    savePickingList(list: PickingList) {
        const lists = this.getPickingLists();
        lists.unshift(list);
        localStorage.setItem(this.key, JSON.stringify(lists));
    }

    getPickingLists(): PickingList[] {
        const data = localStorage.getItem(this.key);
        return data ? JSON.parse(data) : [];
    }

}
